// @flow

import { connect } from 'react-redux';
import { compose } from 'redux';

import { withPageMeta } from '@gandi/app-runner';
import { needsAuth } from '@gandi/authentication';
import { setCartReselleeId as setCartCustomer } from '@gandi/cart';
import { selectCurrentId } from '@gandi/redux-sharing';
import { withTranslator } from '@gandi/translate';

import { getFormValues, actions } from 'gandi.react-form';

import { createCustomer } from 'src/Cart/Customer/modules/customers';
import { withRouter } from 'src/helpers/withRouter';

import type { FullState, MapDispatchToProps } from '../../types';
import CustomerForm from '../Customer/components/Form';

import Presenter, { type StateProps, type DispatchProps } from './Presenter';

// $FlowFixMe[prop-missing]
const selectCustomerFormValues = getFormValues(CustomerForm.FORM_ID);
const mapStateToProps = (state: FullState): StateProps => {
  const customerFormValues = selectCustomerFormValues(state);

  return {
    customerFormValues,
    sharingId: selectCurrentId(state),
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps> = {
  createCustomer,
  setCartCustomer,
  // $FlowFixMe[prop-missing]
  destroyForm: actions.destroy.bind(null, CustomerForm.FORM_ID),
};

export default (compose(
  withTranslator({ propsNamespace: 'translator' }),
  needsAuth,
  withRouter,
  withPageMeta(args => ({
    title: args.__('Choose billing and ownership information - Gandi.net'),
  })),
  connect(mapStateToProps, mapDispatchToProps),
)(Presenter): React.ComponentType<{}>);
